'use strict';
var ENVIRONMENT = require('../internals/environment');

module.exports = ENVIRONMENT === 'NODE';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-is-node.js
// module id = 134
// module chunks = 113